export const GET_CRM_WEB_CONFIGURATION = 'GET_CRM_WEB_CONFIGURATION';
export const REDUCE_CRM_WEB_CONFIGURATION = 'REDUCE_CRM_WEB_CONFIGURATION';
